// src/services/apiService.js
import axios from 'axios'
import useAuthStore from '@/store/authStore.js'
// import { updateCookies } from '@/plugins/cookie-updater'
import router from '@/router'

export default {
  async sendRequestWithBearer (method, url, token, payload = null) {
    const config = {
      method: method,
      maxBodyLength: Infinity,
      url: url,
      headers: {
        // 'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token
      }
    }

    if (payload != null) {
      config.data = payload
      // *** LOGICA CONDIZIONALE PER Content-Type ***
      if (payload instanceof FormData) {
        // Per FormData, NON impostare Content-Type. Axios lo gestirà.
        // config.headers['Content-Type'] = 'multipart/form-data'; // Commentalo!

      } else {
        // Per altri tipi di payload (es. JSON), imposta application/json
        config.headers['Content-Type'] = 'application/json'
        //  config.data = payload // Assegna il payload come JSON
      }
      // Per FormData, 'data' viene assegnato qui sotto, dopo la logica di Content-Type
    }

    try {
      const response = await axios.request(config)
      if (response.status === 200) {
        return response.data
      } else if (response.status === 400) {
        return { error: response.status, details: response.data }
      } else {
        // console.error('Errore nella richiesta con Bearer:', response)
        throw new Error(`Richiesta fallita con stato ${response.status}`)
      }
    } catch (error) {
      const status = error.response?.status

      // SESSIONE SCADUTA
      if (status === 401 || status === 419) {
        handleSessionExpired()
        return null
      }

      if (status === 400) {
        return { error: status, details: error.response.data }
      }

      console.error('Errore nella richiesta con Bearer:', error)
      return null
    }
  },

  async getClientCredentialsToken () {
    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    // params.append('time', timeStamp)

    try {
      const response = await axios.post('ajax/auth.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          // updateCookies()
          return response.data.access_token
        } else {
          // console.error('Errore: access_token non trovato nella risposta.')
          return null
        }
      } else {
        // console.error('Errore nella richiesta del token:', response)
        return null
      }
    } catch (error) {
      // console.error('Errore nella richiesta del token:', error)

      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
      // throw error
    }
  },
  async getLoginUserToken (token, form) {
    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    params.append('token', token)
    params.append('_uigoru', form.username)
    params.append('_pigoru', form.password)
    params.append('rememberme', form.rememberme)

    try {
      const response = await axios.post('ajax/auth.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          return response.data
        } else {
          // console.error('Errore: access_token non trovato nella risposta.')

          if (status === 401 || status === 419) {
            handleSessionExpired()
          }
          return null
        }
      } else {
        // console.error('Errore nella richiesta del token:', response)

        if (status === 401 || status === 419) {
          handleSessionExpired()
        }
        return null
      }
    } catch (error) {
      // console.error('Errore nella richiesta del token:', error)

      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
      // throw error
    }
  },

  async changePassword (form) {
    const params = new URLSearchParams()
    const session = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    params.append('session', session)
    params.append('newpass', form.password)
    params.append('changePassword', 1)

    try {
      const response = await axios.post('ajax/auth.php', params, {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        maxBodyLength: Infinity
      })

      const status = response?.status

      if (status === 200) {
        if (response.data && response.data.access_token && response.data.response === 'OK') {
          return response.data
        } else {
          if (status === 401 || status === 419) {
            handleSessionExpired()
          }
          return null
        }
      } else {
        if (status === 401 || status === 419) {
          handleSessionExpired()
        }
        return null
      }
    } catch (error) {
      if (status === 401 || status === 419) {
        handleSessionExpired()
      }
      return null
    }
  },

  async logout () {
    try {
      const params = new URLSearchParams()
      const session = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (session) {
        params.append('session', session)
        await axios.post('ajax/logout.php', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      }
    } catch (_) {
    // ignora errori server
    }

    useAuthStore.dispatch('logout')
    localStorage.removeItem('authStore')
    localStorage.removeItem('SettingsStore')
    localStorage.removeItem('listitem')

    return true
  }

}

function handleSessionExpired () {
  // evita loop
  if (router.currentRoute.name !== 'login') {
    try {
      const params = new URLSearchParams()
      const session = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
      if (session) {
        params.append('session', session)
        axios.post('ajax/logout.php', params, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
      }
    } catch (_) {
    // ignora errori server
    }

    useAuthStore.dispatch('logout')
    localStorage.removeItem('authStore')
    localStorage.removeItem('SettingsStore')
    localStorage.removeItem('listitem')

    return true
  }
}
